import { RouterType } from '@online-webinar/router';
import { InterestedAccounts } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/interested-accounts'].update({
        staticData: { title: { page: 'Insights.Interested.PageHeading', forWebinar: true } },
        component: authGuard(InterestedAccounts, { canBroadcast: true })
    });
};
